function injectData(cartData) {
  const variantIdFor1500 = 36757852455075;
  const variantIdFor2000 = 36757857534115;
  const variantIdFor2500 = 36757863366819;
  const variantIdForMan1500 = 39508273037475;

  const items = cartData.items;
  const variantIdsAlongWithDataToBeAdded = {};
  variantIdsAlongWithDataToBeAdded[variantIdFor1500] = 0;
  variantIdsAlongWithDataToBeAdded[variantIdFor2000] = 0;
  variantIdsAlongWithDataToBeAdded[variantIdFor2500] = 0;
  variantIdsAlongWithDataToBeAdded[variantIdForMan1500] = 0;
  items.forEach((singleCartItem) => {
    let additionalPrice = 0;
    if (singleCartItem && singleCartItem.properties) {
      additionalPrice = +singleCartItem.properties['__price'];
      if (isNaN(additionalPrice)) {
        additionalPrice = 0;
      }
    }

    if (additionalPrice) {
      const currentQuantity = singleCartItem.quantity;

      let variantIdToBeAdded = '';
      if (additionalPrice === 1800) {
        variantIdToBeAdded = variantIdFor1500;
      } else if (additionalPrice === 2400) {
        variantIdToBeAdded = variantIdFor2000;
      } else if (additionalPrice === 2900) {
        variantIdToBeAdded = variantIdFor2500;
      }
      else if (additionalPrice === 1700) {
        variantIdToBeAdded = variantIdForMan1500;
      }

      if (variantIdToBeAdded) {
        const currentData =
          variantIdsAlongWithDataToBeAdded[variantIdToBeAdded];
        if (currentData) {
          variantIdsAlongWithDataToBeAdded[
            variantIdToBeAdded
          ] += currentQuantity;
        } else {
          variantIdsAlongWithDataToBeAdded[
            variantIdToBeAdded
          ] = currentQuantity;
        }

        // let formData = {
        //   'items': [{
        //   'id': 36110175633573,
        //   'quantity': 2
        //   }]
        // };
      }
    }
  });

  if (Object.keys(variantIdsAlongWithDataToBeAdded).length === 0) {
    redirectToCheckout();
  } else {
    updateItemInCartCustom(variantIdsAlongWithDataToBeAdded);
  }
}

function redirectToCheckout() {
  // toggleCheckoutButtonLoadingState(false);
  window.location.href = '/checkout';
}

function updateItemInCartCustom(cartNewJson) {
  var e = {
    type: 'POST',
    url: '/cart/update.js',
    data: {
      updates: cartNewJson
    },
    dataType: 'json',
    success: function () {
      console.log('data successfully added to cart with extra prices');
      redirectToCheckout();
    },
    error: function (t, r) {
      console.log('data failed to be added to cart with extra prices', t, r);
      redirectToCheckout();
    }
  };
  jQuery.ajax(e);
}

function changeCartItemAttributes(updateJSON) {
  return new Promise(function (resolve) {
    const e = {
      type: 'POST',
      url: '/cart/change.js',
      data: updateJSON,
      dataType: 'json',
      success: function () {
        resolve();
      },
      error: function (t, r) {
        resolve();
      }
    };
    jQuery.ajax(e);
  });
}

function getCurrentProductDataByHandle(handle) {
  return new Promise(function (resolve) {
    const e = {
      type: 'GET',
      url: `/products/${handle}.js`,
      dataType: 'json',
      success: function (data) {
        resolve({
          hasError: false,
          data
        });
      },
      error: function (t, r) {
        resolve({
          hasError: true
        });
      }
    };
    jQuery.ajax(e);
  });
}

async function updateAllLineItemProperties(
  currentCartData,
  hashMapOfVariantsAlongWithDesignCode
) {
  try {
    const items = currentCartData.items;

    const itemsToUpdate = items
      .map((singleCartItem, index) => {
        const optionWithValues = singleCartItem.options_with_values;
        if (optionWithValues && optionWithValues.length > 0) {
          const currentVariantId = singleCartItem.variant_id;
          let currentProperty = singleCartItem.properties;
          currentProperty = currentProperty ? currentProperty : {};
          const currentFinalProperties = {};
          Object.entries(currentProperty).forEach(([K, V]) => {
            if (K && V) {
              currentFinalProperties[K.toLowerCase()] = V;
            }
          });
          const optionWithValuesToObject = {};
          let anyItemsFoundInOptionWithValues = false;
          optionWithValues.forEach((singleItem) => {
            if (singleItem.name && singleItem.value) {
              //ignoring skus which are having only one variants
              //and are no more required
              if (singleItem.value.toLowerCase() !== 'default title') {
                anyItemsFoundInOptionWithValues = true;
                optionWithValuesToObject[singleItem.name.toLowerCase()] =
                  singleItem.value;
              }
            }
          });

          const finalProperties = {
            ...currentProperty,
            ...optionWithValuesToObject
          };
          if (!finalProperties['size']) {
            anyItemsFoundInOptionWithValues = true;
            finalProperties['size'] = 'none';
          }
          if (!finalProperties['color']) {
            anyItemsFoundInOptionWithValues = true;
            finalProperties['color'] = 'none';
          }
          if (hashMapOfVariantsAlongWithDesignCode[currentVariantId]) {
            console.log('updating custom variant id');
            anyItemsFoundInOptionWithValues = true;
            
            var productHandle = singleCartItem.handle;
  			productHandle = productHandle.toUpperCase();
            
            
            var i = currentVariantId;
          let design = $(`#${i}_design`);
          let color = $(`#${i}_color`);
          
          if(!design){
         design = $(`#design`);
        }
       if(design){
        design = design.val();
       }
      if(!color){
        color = $(`#color`);
      }
      if(color){
        color = color.val();
      }
            finalProperties['design_code'] =
              productHandle;
            finalProperties['__Color'] =
              color;
            finalProperties['__Design'] =
              design;
            
          }

          if (!anyItemsFoundInOptionWithValues) {
            return null;
          }
          return {
            line: index + 1,
            quantity: singleCartItem.quantity,
            properties: finalProperties
          };
        }
        return null;
      })
      .filter((item) => item !== null);

    console.log('items to update are: ', itemsToUpdate);
    if (itemsToUpdate.length === 0) {
      //no line items to update for now
      injectData(currentCartData);
      return;
    }

    //there are some valid cart items found to be updated
    for (const singleItem of itemsToUpdate) {
      await changeCartItemAttributes(singleItem);
    }
    //start injecting cart data now
    injectData(currentCartData);
  } catch (err) {
    injectData(currentCartData);
  }
}

async function pause(time = 1000) {
  return new Promise((resolve) => {
    setTimeout(resolve, time);
  });
}

async function fetchDesignCodeForVariants(
  listOfHandles,
  callbackFunction,
  hashMapForVariantsAsKey = {},
  retryCount = 0
) {
  let handlesToRetry = await Promise.all(
    listOfHandles.map(async (singleHandle) => {
      const singleProductData = await getCurrentProductDataByHandle(
        singleHandle
      );
      if (singleProductData.hasError) {
        return singleHandle;
      }
      const tags = singleProductData.data.tags || [];
      let designCode = tags.filter(
        (singleTag) => singleTag && singleTag.includes('designcode_')
      );
      if (designCode.length === 0) {
        return null;
      }
      designCode =
        designCode.length > 0 && designCode[0].replace('designcode_', '');
      const variants = singleProductData.data.variants;
      variants.forEach(
        (singleVariant) =>
          (hashMapForVariantsAsKey[singleVariant.id] = designCode)
      );
      return null;
    })
  );

  handlesToRetry = handlesToRetry.filter(
    (singleHandle) => singleHandle !== null
  );

  if (handlesToRetry.length > 0 && retryCount < 3) {
    await pause();
    return await fetchDesignCodeForVariants(
      handlesToRetry,
      callbackFunction,
      hashMapForVariantsAsKey,
      retryCount + 1
    );
  }

  console.log('hashMapForVariantsAsKey:  ', hashMapForVariantsAsKey);
  callbackFunction(hashMapForVariantsAsKey);
}

function toggleCheckoutButtonLoadingState(isLoading) {
  try {
    const cartSliderCheckoutButtonLoader = $('#mini-cart-custom-loader');
    const cartSliderCheckoutButton = $('#cartDWcheckout');
    const mainCartPageCheckoutButton = $('#cartCheckout');
    if (cartSliderCheckoutButtonLoader) {
      if (isLoading) {
        cartSliderCheckoutButtonLoader.show();
      } else {
        cartSliderCheckoutButtonLoader.hide();
      }
    }
    if (mainCartPageCheckoutButton) {
      if (isLoading) {
        mainCartPageCheckoutButton.prop('disabled', true);
      } else {
        mainCartPageCheckoutButton.prop('disabled', false);
      }
    }
    if (cartSliderCheckoutButton) {
      if (isLoading) {
        cartSliderCheckoutButton.prop('disabled', true);
      } else {
        cartSliderCheckoutButton.prop('disabled', false);
      }
    }
  } catch (err) {}
}

function addAdditionalItemsToCart() {
  toggleCheckoutButtonLoadingState(true);

  $.getJSON('/cart.js', function (t) {
    const cartData =  t;

    const uniqueHandlesSet = new Set();

    cartData.items.forEach((singleCurrentItem) => {
      uniqueHandlesSet.add(singleCurrentItem.handle);
    });

    const uniqueHandlesOnly = [...uniqueHandlesSet];

    fetchDesignCodeForVariants(
      uniqueHandlesOnly,
      function (hashMapOfVariantsAlongWithDesignCode) {
        updateAllLineItemProperties(
          cartData,
          hashMapOfVariantsAlongWithDesignCode
        );
      }
    );
  });
}
